export default __webpack_public_path__ + "static/media/channel1.876f39ee.svg";